<template>
    <div>
      <div class="reconciliation">
        <div class="reconciliation-one">
            <div class="reconciliationTable">
            <el-table
                :data="tableData"
                stripe
                border
                ref="typeTable"
                :row-key="getRowKeys"
                style="width: 100%">
                <el-table-column
                    prop="order_id"
                    label="ID"
                >
                </el-table-column>
                <el-table-column
                    prop="order_no"
                    label="订单号"
                    show-overflow-tooltip
                   >
                </el-table-column>
                <el-table-column
                    prop="total_price"
                    label="总金额"
                   >
                </el-table-column>
                <el-table-column
                    prop="addtime"
                    label="添加时间"
                    show-overflow-tooltip
                   >
                </el-table-column>
                <el-table-column
                    prop="pay_price"
                    label="支付金额"
                    show-overflow-tooltip
                    >
                </el-table-column>
                <el-table-column
                    prop="is_pay"
                    label="是否支付"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        <!-- <span v-show="scope.row.is_payment==2">平台确认已打款</span> -->
                        <span v-show="scope.row.is_pay==1">已支付</span>
                        <span v-show="scope.row.is_pay==0">未支付</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_send"
                    label="是否发货"
                   >
                   <template slot-scope="scope">
                        <span v-show="scope.row.is_send==1">已发货</span>
                        <span v-show="scope.row.is_send==0">未发货</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_confirm"
                    label="是否确认"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_confirm==1">是</span>
                        <span v-show="scope.row.is_confirm==0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_cancel"
                    label="是否取消"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_cancel==1">是</span>
                        <span v-show="scope.row.is_cancel==0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_revoke"
                    label="是否取消退款"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_revoke==1">是</span>
                        <span v-show="scope.row.is_revoke==0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="apply_delete"
                    label="是否申请删除"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.apply_delete==1">是</span>
                        <span v-show="scope.row.apply_delete==0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="pay_type"
                    label="支付方式"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="payment"
                    label="支付方式"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.payment==1">微信</span>
                        <span v-show="scope.row.payment==2">工行</span>
                        <span v-show="scope.row.payment==3">支付宝</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="delClick(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="goods-paging d-flex align-items-center justify-content-center">
				<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="limit"
					:hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination>
		    </div>
            <div class="reconciliationbutton">
                <div></div>
                <div class="other-but">
                    <div class="sub" @click="statementAccount()">确定</div>
                </div>
            </div>
        </div>
      </div>
      <div>
        <el-dialog
            title="备注"
            :visible.sync="desVisible"
            width="1080px"
            :modal=false
            :before-close="handleClose">
            <el-input type="textarea" v-model="remarks" :rows="5" placeholder="请输入内容"></el-input>
            <span slot="footer" class="dialog-footer">
                <div style="cursor: pointer;
                    width: 70px;
                    height: 32px;
                    background: #ff0e25;
                    border-radius: 2px;
                    color: #fff;
                    line-height: 32px;
                    font-size: 14px;
                    font-weight: 400;
                    text-align: center;" @click="endOrder()">确 定</div>
            </span>
        </el-dialog>
      </div>
    </div>
  </template>
  <script>
  import './reconciliation.css'
  export default {
    props:['active'],
    data() {
      return {
        checkVisible:false,
        desVisible:false,
        remarks:"",
        currentPage: 1, //页数
		ttshop_znum: 0, //总商品数
		limit: 9, //每页条数
		page_count: '', //总页数
        partnerList: [{value: 1,label: '是'},{value: 2,label: '否'}
        ],
        billList:[{value:1,label: '是'},{value:0,label: '否'},],
        tableData: [],
        selectExportId: [], // 多选表格的id
        selectEndId:[]//最终选择id
      }
    },
    created() {
        // console.log(this.active,"1212")
     this.uncheckdraft()
    },
    mounted() {},
    methods: {
        addCheck(){
            this.checkVisible=true
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        // 分页
        handleCurrentChange(e) {
				this.currentPage= e;
				this.uncheckdraft()
		},
     
      // 未对账草稿订单
        uncheckdraft() {
            this.$api.draftsList({
                shop_type: 'qycg',
                // access_token: this.$store.state.qycg_user.access_token
                page: this.currentPage,
                limit: this.limit,
            })
            .then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list;
                    this.ttshop_znum = Number(res.data.row_count);
                    this.page_count = res.data.page_count;
                } else {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'warning',
                    offset: 200,
                    duration: 1000
                })
                }
            })
            .catch(err => {
                // console.log(err);
            })
        },
        getRowKeys(row) {
            return row.order_id;
        },
        selectChange(row){
            console.log('调用了');
            this.selectExportId = row.map((item) => item.order_id);
            // this.single = selection.length !== 1;
            // this.multiple = !selection.length;
            // console.log(this.selectExportId,"row")
        },
        // 删除
        delClick(row) {
            this.$confirm('确认删除当前账单吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(() => {
					this.$api.delDrafts({
						shop_type: 'qycg',
                        order_id:row.order_id
					}).then(res => {
                        if(res.code==0){
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'success',
                                offset: 200,
                                duration: 1000
                            })
                            this.uncheckdraft()
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'warning',
                                offset: 200,
                                duration: 1000
                            })
                        }
					}).catch(err => {
						// console.log(err);
					});
				}).catch(() => {});
        },
        statementAccount(){
            this.desVisible=true
        },
        // 最终确定
        endOrder(){
            this.selectEndId =this.tableData.map((item) => item.order_id);
            // console.log(  this.selectEndId,"  this.selectEndId")
            this.$api.addcheckOrder({
                shop_type: 'qycg',
                // access_token: this.$store.state.qycg_user.access_token
                check_orders:this.selectEndId,
                // check_orders:this.selectEndId,
                remarks:this.remarks
            })
            .then(res => {
                if (res.code == 0) {
                    this.$emit('closed')
                    this.desVisible=false
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'warning',
                        offset: 200,
                        duration: 1000
                    })
                }
            })
            .catch(err => {
                this.$message({
                        showClose: true,
                        message: "服务器错误",
                        type: 'warning',
                        offset: 200,
                        duration: 1000
                    })
                // console.log(err);
            })
            
        }
       

    }
  }
  </script>
  <style lang="scss" scoped>
  .reconciliation {
    width: 100%;
    .reconciliation-one {
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        .purHead{
          width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            // border: 1px solid #ddd;
            border-radius: 6px;
            box-sizing: border-box;
            padding: 10px 30px 12px 30px;
            line-height: 16px;
          }
      
      .reconciliationFrom {
        width: 100%;
        padding: 24px 15px 0px 20px;
        box-sizing: border-box;
        margin: 0 auto;
  
        .flex {
          display: flex;
        }
        .sub {
          cursor: pointer;
          width: 70px;
          height: 32px;
          background: #ff0e25;
          border-radius: 2px;
          color: #fff;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          text-align: center;
          
        }
        .sadd{
            cursor: pointer;
              width: 80px;
              height: 32px;
              background: #ff0e25;
              border-radius: 2px;
              color: #fff;
              line-height: 32px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              text-align: center;
              margin-left: 5px;
        }
      }
      .reconciliationTable{
        // padding: 0px 15px 24px 20px;
      }
      .reconciliation_pages{
            display: flex;
            width: 100%;
			margin-top: 20px;
            justify-content: space-between;
      }
      .reconciliationbutton{
        display: flex;
        justify-content:flex-end ;
        .other-but{
            margin: 10px 15px 5px 0  ;
            .sub {
                cursor: pointer;
                width: 70px;
                height: 32px;
                background: #ff0e25;
                border-radius: 2px;
                color: #fff;
                line-height: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: center;
            }
        }
        
      }
    }
  }
  </style>